var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "133px",
    viewBox: "0 0 144 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Miscellaneous/Logotypes/colorful/talk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "81.9865175%",
    x2: "79.3721548%",
    y2: "16.8901338%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Final-for-InVision",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-24.000000, -29.929451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,30.0004 C160,30.0004 168,34.2804 168,42.0004 L168,42.0004 L168,102.0004 C168,109.7204 160,114.0004 156,114.0004 L156,114.0004 L140,114.0004 L140,127.8989 C140,135.6189 133.72,141.8989 126,141.8989 L72.468,141.8989 L56.585,159.6099 C54.708,161.2519 52.393,162.1019 50.034,162.1019 C48.633,162.1019 47.217,161.8019 45.868,161.1899 C42.249,159.5469 40,156.0579 40,152.0839 L40,141.8989 L38,141.8989 C30.28,141.8989 24,135.6189 24,127.8989 L24,70.8989 C24,63.1789 28.28,58.8989 36,58.8989 L52,58.8984 L52,42.0004 C52,34.3991692 59.7557396,30.1329065 63.8125881,30.003436 L64,30.0004 Z M52,70.8984 L39.8427141,70.8992512 C38.6452114,70.9068012 36,71.0766778 36,74.8989 L36,127.8989 C36,129.0019 36.897,129.8989 38,129.8989 L52,129.8989 L52,147.2779 L67.532,129.8989 L126,129.8989 C127.103,129.8989 128,129.0019 128,127.8989 L128,114.0004 L64,114.0004 C60.0615385,114.0004 52.2452071,109.851079 52.0056368,102.354262 L52,102.0004 L52,70.8984 Z M124.157286,70.8992512 L64,70.8984 L64.0003512,98.0234014 C64.0077257,98.3405043 64.1699643,101.832323 67.7392154,101.994562 L68,102.0004 L128,102.0004 L128,74.8989 C128,71.0766778 125.354789,70.9068012 124.157286,70.8992512 Z M152,42.0004 L68,42.0004 C64.1777778,42.0004 64.0079012,45.6527457 64.0003512,45.9773986 L64,58.8984 L128,58.8989 C135.72,58.8989 140,63.1789 140,70.8989 L140,102.0004 L152,102.0004 C155.911111,102.0004 155.998025,98.1762025 155.999956,98.0062381 L156,98.0004 L156,46.0004 C156,46.0004 156,42.0004 152,42.0004 L152,42.0004 Z M80,82.0004 C82.209,82.0004 84,83.7914 84,86.0004 C84,88.2094 82.209,90.0004 80,90.0004 C77.791,90.0004 76,88.2094 76,86.0004 C76,83.7914 77.791,82.0004 80,82.0004 Z M96,82.0004 C98.209,82.0004 100,83.7914 100,86.0004 C100,88.2094 98.209,90.0004 96,90.0004 C93.791,90.0004 92,88.2094 92,86.0004 C92,83.7914 93.791,82.0004 96,82.0004 Z M112,82.0004 C114.209,82.0004 116,83.7914 116,86.0004 C116,88.2094 114.209,90.0004 112,90.0004 C109.791,90.0004 108,88.2094 108,86.0004 C108,83.7914 109.791,82.0004 112,82.0004 Z",
    id: "talk",
    fill: "url(#linearGradient-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkLogo);
export default __webpack_public_path__ + "20a13187a3f10606b3af9068677d269d.svg";
export { ForwardRef as ReactComponent };